import "ui/index.css";
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { Provider } from "react-redux";
import store from "store/src/store";
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from "utils/react-query.js";

createRoot(document.getElementById('root')).render(

    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>

)